import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'
import { geoData } from '@fs/zion-config'

export default function usePopularLinks({ isNonEnCoreLanguage }) {
  const { t } = useTranslation()
  const popularLinksIsOn = useFeatureFlag('home_fatFooter_otherLinks').isOn

  const isSpanishOrPortuguese = i18n.language === 'es' || i18n.language === 'pt'
  const isLatinAmerica = [
    'MX',
    'BZ',
    'CR',
    'SV',
    'GT',
    'HN',
    'NI',
    'PA',
    'AG',
    'BS',
    'BB',
    'CU',
    'DM',
    'DO',
    'GD',
    'HT',
    'JM',
    'KN',
    'LC',
    'MF',
    'PR',
    'VC',
    'TT',
    'AR',
    'BO',
    'BR',
    'CL',
    'CO',
    'EC',
    'GY',
    'PY',
    'PE',
    'SR',
    'UY',
    'VE',
  ].includes(geoData?.country)

  return {
    id: 'popularLinks',
    title: t('nav.popular', 'Popular in Your Region'),
    hidden: !isNonEnCoreLanguage || !popularLinksIsOn,
    subNav: [
      {
        id: 'build_tree',
        text:
          isLatinAmerica && isSpanishOrPortuguese
            ? t('nav.links.popular.buildGenealogicalTree', 'Build a Genealogical Tree')
            : t('nav.links.popular.buildTree', 'Build a Family Tree'),
        url: `/${i18n.language}/family-tree/`,
        linkName: 'ff_popular_build_tree',
        dataTestId: 'ff_build_tree',
        isNew: false,
      },
      {
        id: 'vital_records',
        text: t('nav.links.popular.vitalRecords', 'Explore Birth, Marriage, and Death Records'),
        url: `/search/collection/list/?fcs=recordType%3AVITAL&ec=recordType%3AVITAL`,
        linkName: 'ff_popular_vital_records',
        dataTestId: 'ff_vital_records',
        isNew: false,
      },
      {
        id: 'discover_ancestors',
        text: t('nav.links.popular.discover', 'Discover Your Ancestors'),
        url: `/${i18n.language}/blog/find-your-family`,
        linkName: 'ff_popular_discover_ancestors',
        dataTestId: 'ff_find_family',
        isNew: false,
      },
      {
        id: 'heritage',
        text: t('nav.links.popular.heritage', 'Learn about Your Heritage'),
        url: `/${i18n.language}/discovery/explore/`,
        linkName: 'ff_popular_heritage',
        dataTestId: 'ff_heritage',
        isNew: false,
      },
    ],
  }
}
